import { GoJsModelProperties, genericToolTip } from '@y42/gojs';
import { variableColors } from '@y42/model';
import { Adornment, Binding, Geometry, GraphObject, Shape } from 'gojs';
import { GojsBasePartConfig } from '../models/gojs-part.model';

interface GoJSButtonConfig extends GojsBasePartConfig {
  partName: string;
  toolTip?: Adornment;
}

const $ = GraphObject.make;

const config = {
  svg: 'M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM12 8c-1.105 0-2 0.895-2 2s0.895 2 2 2h5.172l-8.586 8.586c-0.781 0.781-0.781 2.047 0 2.829 0.39 0.39 0.902 0.586 1.414 0.586s1.024-0.195 1.414-0.586l8.586-8.586v5.172c0 1.105 0.895 2 2 2s2-0.895 2-2v-12h-12z',
  fill: {
    lightMode: variableColors.gray300,
    darkMode: variableColors.gray300Dark,
  },
  border: 'transparent',
  hover: {
    fill: 'transparent',
    border: variableColors.gray500,
  },
};

const shape = () =>
  $(
    Shape,
    {
      width: 20,
      height: 20,
      strokeWidth: 0,
      geometry: Geometry.parse(config.svg, true),
    },
    new Binding('fill', GoJsModelProperties.HasDarkMode, (hasDarkMode: boolean) => {
      return hasDarkMode ? config.fill.darkMode : config.fill.lightMode;
    }).ofModel(),
  );

export const RedirectButton = ({ partName, bindings, toolTip }: GoJSButtonConfig) =>
  $(
    'Button',
    {
      name: partName,
      'ButtonBorder.stroke': null,
      'ButtonBorder.strokeWidth': 2,
      'ButtonBorder.fill': config.border,
      _buttonFillOver: config.hover.fill,
      _buttonStrokeOver: config.hover.border,
      _buttonFillDisabled: 'transparent',
      toolTip: toolTip ?? DefaultTooltip(),
    },
    shape(),
    ...(bindings ?? []),
  );

const DefaultTooltip = () =>
  genericToolTip({ colors: { fill: variableColors.white, stroke: variableColors.gray700 } }, [
    new Binding('text', '', () => 'Redirect To'),
  ]);
